import http from '@/http'

export type WidgetPdfExportDto = {
  outputFile?: string,
  state: string
}

export type WidgetPdfExportParams = {
  chapterId?: number,
  mediaId?: number,
  pageId?: number
}

export async function createWidgetPdfExport (params: WidgetPdfExportParams) {
  const { data } = await http.post<number>('printer/widget-pdf', null, { params })
  return data
}

export async function getWidgetPdfExport (jobId: number) {
  const { data } = await http.get<WidgetPdfExportDto>(`printer/widget-pdf/${jobId}`)
  return data
}

export async function getExportFile (url: string) {
  const { data } = await http.get<Blob>(url.replace(/^\/api\//, ''), { responseType: 'blob' })
  return data
}
